@if (loader()) {
	<div class="d-flex flex-column justify-content-center align-items-center h-400">
		@if (sendProgress() !== null) {
			<mat-progress-bar mode="determinate" [value]="sendProgress()"></mat-progress-bar>
			<span class="text-center mt-2 fw-bold">{{ sendProgress() }}%</span>
		} @else {
			<mat-spinner></mat-spinner>
		}
	</div>
} @else {
	<div class="overflow-auto" style="max-height: 80vh">
		<form>
			<div class="row mx-0">
				<mat-form-field class="col-4">
					<mat-label>Szablony</mat-label>
					<mat-select [(ngModel)]="selectedTemplate" name="templates">
						@for (template of templates(); track template.name) {
							<mat-option [value]="template">{{ template.name }}</mat-option>
						}
					</mat-select>
				</mat-form-field>

				@if (isEmail()) {
					<mat-form-field class="col-8">
						<mat-label>DW</mat-label>
						<input
							type="text"
							matInput
							[formControl]="ccControl"
							appMailList
							placeholder="example&#64;mail.com, example2&#64;mail.com"
						/>
						@if (ccControl.hasError('mailListSeparator')) {
							<mat-error
								>Adresy e-mail muszą być oddzielone przecinkiem i spacją (np. example&#64;gmail.com,
								example2&#64;gmail.com)</mat-error
							>
						} @else if (ccControl.hasError('mailListEmail')) {
							<mat-error>
								Nieprawidłowe adresy e-mail:
								{{ ccControl.getError('mailListEmail')?.invalid.join(', ') }}
							</mat-error>
						}
					</mat-form-field>
				}
			</div>

			<hr class="my-3" />

			<mat-form-field appearance="fill" class="w-100">
				<mat-label
					>Szablon {{ type() === MessageType.SMS ? 'SMS' : type() === MessageType.EMAIL ? 'mail' : '' }}
				</mat-label>
				<textarea
					matInput
					[formControl]="templateControl"
					rows="6"
					placeholder="Wpisz treść {{
						type() === MessageType.SMS ? 'sms' : type() === MessageType.EMAIL ? 'mail' : ''
					}}..."
				>
				</textarea>
				@if (templateControl.hasError('required')) {
					<mat-error> To pole jest wymagane </mat-error>
				} @else if (templateControl.hasError('invalidTemplateVariables')) {
					<mat-error
						>Znaleziono nieprawidłowe zmienne:
						{{ templateControl.getError('invalidTemplateVariables')?.invalid.join(', ') }}</mat-error
					>
				} @else if (templateControl.hasError('invalidFormat')) {
					<mat-error>
						Błędny format zmiennej:
						{{ templateControl.getError('invalidFormat')?.invalid.join(', ') }}</mat-error
					>
				} @else if (templateControl.hasError('invalidHtmlTags')) {
					<mat-error>
						Nieprawidłowe znaczniki HTML:
						{{ templateControl.getError('invalidHtmlTags')?.invalid.join('; ') }}
					</mat-error>
				}
			</mat-form-field>
		</form>

		@if (!!propertiesKeys().length) {
			<hr class="my-3" />

			<div class="d-flex flex-wrap gap-3">
				@for (propertyValue of propertiesKeys(); track propertyValue) {
					<button
						[cdkCopyToClipboard]="propertyValue"
						(cdkCopyToClipboardCopied)="copied(propertyValue)"
						mat-stroked-button
					>
						{{ propertyValue }}
					</button>
				}
			</div>
		}

		@if (previewList()?.length > 0) {
			<hr class="my-3" />

			<section class="sms-list-container">
				<ng-container
					[ngTemplateOutlet]="previewTemplate()"
					[ngTemplateOutletContext]="{
						$implicit: previewList(),
						previewLoader: previewLoader(),
						attachmentsByItem: attachmentsByItem(),
					}"
				></ng-container>
			</section>
		}

		<hr class="my-3" />
	</div>

	<div class="w-100 text-end">
		<button
			[disabled]="!previewList()?.length || previewLoader() || (isEmail() && ccControl.invalid)"
			mat-raised-button
			color="primary"
			(click)="send()"
		>
			Wyślij {{ type() === MessageType.SMS ? 'sms' : type() === MessageType.EMAIL ? 'mail' : '' }}
		</button>
	</div>
}
